export default {
  status1: ['审核中', '驳回', '通过'],
  status2: ['待提交', '待企业审核', '驳回', '通过'],

  getStatus(role, status) {
    if (role === 0) {
      return this.status1[status - 1];
    } else {
      return this.status2[status];
    }
  },
  getOperation(role, status) {
    const operations = [];
    if (role === 0) {
      if ([1].includes(status)) {
        operations.push('审核');
      } else {
        operations.push('查看');
      }
    } else {
      if ([0, 2].includes(status)) {
        operations.push('修改');
      }
      if ([1, 3].includes(status)) {
        operations.push('查看');
      }
    }
    return operations;
  },
};
